'use client';

import { useEffect, useState, useContext } from 'react';
import { useSearchParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { ChevronDown } from 'lucide-react';

import t from '@guestyci/localize/t.macro/t.macro';
import {
  Combobox,
  ComboboxTrigger,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  Row,
} from '@guestyci/arc';

import { useRouter, usePathname } from 'i18n/routing';
import { WebsiteSettingsContext } from 'context/WebsiteSettingsContext';
import { countryCodeToLabel } from 'constants/languages';

const SelectLanguageDropdown = () => {
  const locale = useLocale();
  const router = useRouter();
  const searchParams = useSearchParams();
  const searchParamsString = searchParams.toString() || '';

  const pathname = usePathname();
  const { contentConfiguration: { colorTheme: { colors = {} } = {} } = {} } = useContext(WebsiteSettingsContext);
  const [selectedCountryCode, setSelectedCountryCode] = useState(locale);
  const [languageList, setLanguageList] = useState([]);

  const { enginesData: { languages = [] } = {} } = useContext(WebsiteSettingsContext);

  useEffect(() => {
    if (languages.length) {
      const languageStrings = languages.map(({ language: lang }) => lang);
      setLanguageList(languageStrings);
    }
  }, [languages]);


  if (languages?.length === 1) return null;



  const pathnameWithSearch = `${pathname}?${searchParamsString}`;

  const handleComboboxChange = value => {
    if (!value || value === selectedCountryCode) return;
    setSelectedCountryCode(value);
    router.push(pathnameWithSearch, { locale: value });
  }

  return (
    <Combobox value={selectedCountryCode} onValueChange={handleComboboxChange}>
      <ComboboxTrigger
        className="gst-border-0 gst-bg-transparent gst-h-auto gst-py-0"
        style={{ color: colors?.headerLink || 'inherit' }}
        aria-label={t('Select language')}
      >
        <Row justify="between" align="center" gap={2}>
          {countryCodeToLabel(selectedCountryCode)}
          <ChevronDown className="gst-w-4 gst-h-4" />
        </Row>
      </ComboboxTrigger>
      <ComboboxContent className="gst-min-w-44">
        <ComboboxList>
          {languageList.map((lang) => (
            <ComboboxItem value={lang} key={lang}>
              {countryCodeToLabel(lang)}
            </ComboboxItem>
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
};

export default SelectLanguageDropdown;
